import React from "react";
import { withStyles } from "@material-ui/core/styles";
import gql from "graphql-tag";
import { Query } from "react-apollo";
import OutlinedSelect from "../forms/outlined-select";

const styles = (theme) => ({
	container: {
		marginTop: theme.spacing.unit * 2
	}
});

const GET_LAYERS = gql`
	query($indicator: ID!, $typing: Typing!, $years: InputYearsStats!) {
		availableLayers(indicator: $indicator, typing: $typing, years: $years) {
			_id
			name
			description
			isDefault
		}
	}
`;

const LayerSelect = ({
	value,
	handleChange,
	classes,
	indicator,
	typing,
	years
}) => {
	let arrYears = years.toString().split("-");

	let filterYear = {};
	const getFiltersYears = () => {
		if (arrYears.length === 1) {
			filterYear = {
				upper: parseInt(arrYears[0], 10),
				lower: parseInt(arrYears[0], 10)
			};
		} else if (arrYears.length === 2) {
			filterYear = {
				upper: parseInt(arrYears[0], 10),
				lower: parseInt(arrYears[1], 10)
			};
		} else {
			filterYear = { upper: 0, lower: 0 };
		}

		return {
			indicator,
			typing: typing !== "" ? typing : "MEN",
			years: filterYear
		};
	};

	return (
		<Query
			query={GET_LAYERS}
			/*onCompleted={data => {
        const { availableLayers } = data;
        if (value === "" || !value) {
          allLayers.forEach(layer => {
            if (layer.isDefault) {
              handleChange("layer", layer.id);
            }
          });
        }
      }}*/
			variables={getFiltersYears()}
			fetchPolicy="cache-and-network"
		>
			{({ data, loading, error }) => {
				if (loading || error) {
					return null;
				}
				const items = data.availableLayers
					? data.availableLayers.map((item) => {
							return {
								value: item._id,
								label: item.name
							};
					  })
					: [];
				return (
					<div className={classes.container}>
						<OutlinedSelect
							value={value}
							onChange={(event) => {
								handleChange("layer", event.target.value);
							}}
							label="Unidad"
							name="layer"
							data={items}
						/>
					</div>
				);
			}}
		</Query>
	);
};

export default withStyles(styles)(LayerSelect);



// WEBPACK FOOTER //
// ./src/components/filters/layer.js